<template>
  <div class="filter">
    <div class="innerItem filterInput">
      <p class="innerTitle toCapitalize f_medium">{{locale.search}}</p>
      <input type="text" class="input" :placeholder="locale.tv_search_placeholder" v-model="filter.word">
    </div>
    <div class="innerItem">
      <p class="innerTitle toCapitalize f_medium">{{locale.genre}}</p>
      <div class="filterCategory">
        <div class="item"><span class="checkbox">
          <input type="checkbox" id="genre_all" v-model="chkAll" />
          <label for="genre_all">{{locale.all}}</label>
        </span></div>
        <div v-for="item in genre"
          :key="item" class="item"><div class="checkbox">
          <input type="checkbox" name="genreFilter"
            :id="`genre_${item}`"
            :value="item"
            v-model="filter.genre">
          <label :for="`genre_${item}`" class="toCapitalize">
            {{getGenreName(item)}}
          </label>
        </div></div>
      </div>
    </div>
    <div>
      <p class="innerTitle toCapitalize f_medium">{{locale.language}}</p>
      <div class="filterCategory">
        <div v-for="item in lang"
          :key="item" class="item"><div class="checkbox">
          <input type="checkbox" name="langFilter"
            :id="`lang_${item}`"
            :value="item"
            v-model="filter.lang">
            <label :for="`lang_${item}`" class="toCapitalize">
              {{langName(item)}}
            </label>
        </div></div>
      </div>
    </div>
    <!-- <div class="innerItem">
      <p class="innerTitle toCapitalize f_medium">{{locale.amenity_state_service}}</p>
      <div class="filterCategory">
        <div class="item">
          <span class="checkbox">
            <input type="checkbox" id="view_service_on"
              v-model="listView.serviceOn"
              :disabled="listView.serviceOn && !listView.serviceOff"
              @change="setListView" />
            <label for="view_service_on">{{locale.amenity_state_service_on}}</label>
          </span>
        </div>
        <div class="item">
          <span class="checkbox">
            <input type="checkbox" id="view_service_off"
              v-model="listView.serviceOff"
              :disabled="!listView.serviceOn && listView.serviceOff"
              @change="setListView" />
            <label for="view_service_off">{{locale.amenity_state_service_off}}</label>
          </span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'genre',
    'lang'
  ],
  computed: {
    filter: {
      get () {
        return this.$store.getters['tv/getFilter']
      },
      set (val) {
        const data = {
          word: val.word.trim().toLowerCase(), // 검색어는 대소문자, 공백 무시
          genre: val.genre,
          lang: val.lang
        }
        this.$store.commit('tv/setFilter', data)
      }
    }
  },
  watch: {
    chkAll (isChkAll) {
      const data = {
        genre: isChkAll ? this.genre.map(x => x) : []
      }
      this.$store.commit('tv/setFilter', data)
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      /**
       * 리스트 보기 옵션
       * 서비스중: serviceOn
       * 비서비스: serviceOff
       */
      listView: {
        serviceOn: true,
        serviceOff: true
      },
      chkAll: true
    }
  },
  methods: {
    init () {
      // this.setListView()
      this.$store.commit('tv/initFilter')
    },
    setListView () {
      this.$store.commit('tv/listView', this.listView)
    },
    langName (c) {
      const code = `lang_${c}`
      return this.locale[code]
    },
    getGenreName (id) {
      const genre = `genre_${id}`
      return this.locale[genre]
    }
  }
}
</script>

<style lang="scss" scoped>
.flexBox {
  margin-left: 0;
  margin-right: 0;
  .flexInner {
    padding-left: 0;
    padding-right: 0;
  }
}
.filterCategory {
  max-height: 450px;
  overflow: auto;
  .item {
    margin-bottom: 0.5em;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 10px;
      width: 10px;
      height: 10px;
      margin-top: -5px;
      opacity: 0.2;
    }
    &.active:before {
      opacity: 1;
    }
  }
  .checkbox {
    display: block;
    white-space: nowrap;
  }
}
</style>
